import React from 'react';

import { Box, H3, Text } from '@opendoor/bricks/core';
import Accordion from '@opendoor/bricks/deprecated/UNSAFE_Accordion';

import { useOfferContext } from 'sellDirect/OfferContext';
import { ExternalLink } from 'platform/react-router';

export type FAQItem = {
  answer: React.ReactNode;
  question: React.ReactNode;
};

interface IFAQsProps {
  items: Array<FAQItem>;
}

/** TODO: Add documentation */
const FAQsWithoutContext: React.FC<IFAQsProps> = ({ items }) => {
  return (
    <>
      <H3 mb={4}>FAQ</H3>
      <Accordion
        withBackground={true}
        arrowPosition="right"
        arrowColor="brand50"
        arrowStrokeWidth={0.7}
        multiExpand={false}
        alignBody
        noBorder
        items={items.map(({ question, answer }, index) => ({
          body: <Box whiteSpace="pre-wrap">{answer}</Box>,
          id: `faq_${index}`,
          title: (
            <Text fontSize="s0" lineHeight="s00" color="neutrals100">
              {question}
            </Text>
          ),
        }))}
      />
    </>
  );
};

const EXPIRED_FAQ_ITEMS: Array<FAQItem> = [
  {
    question: 'Why did my offer expire?',
    answer:
      "Your offer expires after 7 days to make sure it's up-to-date with market trends. To request a new offer, visit your dashboard.",
  },
  {
    question: 'How do I get a new offer?',
    answer: (
      <Text>
        Select
        {/* TODO @sellDirect Semantic links without href p props are a11y violations. See
            https://opendoor.atlassian.net/wiki/spaces/SELL/pages/1943339236/Accessibility+best+practices+for+frontend+development#Common-anti-patterns-to-look-out-for-in-progress */}
        <ExternalLink
          fontWeight="bold"
          cursor="default"
          mx={2}
          analyticsName="cake-expired-faqs-refresh-offer"
          aria-label={null}
        >
          Refresh offer
        </ExternalLink>
        and we'll recalculate your offer price. It only takes a few minutes and you won't need to
        complete any extra steps.
      </Text>
    ),
  },
];

/**
 * @deprecated This is a legacy component. Use the `FAQSection` component instead
 *
 * component-test-check-ignore
 */
export const FAQs: React.FC<{ items: Array<FAQItem> }> = (props) => {
  const { offer } = useOfferContext();
  const items = offer?.isExpired ? EXPIRED_FAQ_ITEMS : props.items;
  return <FAQsWithoutContext items={items} />;
};
